import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';
import TimecardIcon from '@material-ui/icons/Schedule';

import backgroundColor from '@material-ui/core/colors/indigo';

import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';
import { editImportTime } from '../../../store/actions';

const styles = theme => ({
  title: {
    backgroundColor: backgroundColor[500],
  },
});

const ImportTime = (props) => {
  const {
    workTypes,
    crew,
    timecards,
    editImportTime
  } = props;

  //console.log("IMPORT list of timecards:", timecards)
  return(
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="dense" variant="head">Type</TableCell>
            <TableCell padding="dense" variant="head">Date</TableCell>
            <TableCell padding="dense" variant="head">Crew</TableCell>
            <TableCell padding="dense" variant="head">Work Type</TableCell>
            <TableCell padding="dense" variant="head">Hrs</TableCell>
            <TableCell padding="dense" variant="head">Rate</TableCell>
            <TableCell padding="dense" variant="head">Total</TableCell>
            <TableCell padding="dense" variant="head">Include</TableCell>
            <TableCell padding="none" variant="head" numeric />
          </TableRow>
        </TableHead>
        <Tooltip type={TooltipTypes.IMPORT_TIME_INCLUDE} placement="bottom">
          <TableBody>
            {timecards &&
              timecards.filter(timecard => !timecard.exclude).map(timecard => {
                const crewItem = crew.find(item => item.id === timecard.crewId);
                const workType = workTypes.find(workType => workType.id === timecard.workTypeId);
                const hours = timecard.minutesWorked
                  ? (timecard.minutesWorked/60).toFixed(1)
                  : 0;
                const rate = workType && workType.rate
                  ? Number(workType.rate).toFixed(2)
                  : 0;
                const total = (hours*rate).toFixed(2);
                return (
                  <TableRow key={timecard.id}>
                    <TableCell padding="dense" variant="body">
                      <TimecardIcon />
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {moment(timecard.startDate).format("MMM Do, YYYY")}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {crewItem && crewItem.crewFirstName}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {workType && workType.name}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {hours}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {`$${rate}`}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      {`$${total}`}
                    </TableCell>
                    <TableCell padding="dense" variant="body">
                      <Checkbox
                        color="primary"
                        checked={timecard.include}
                        onChange={() => editImportTime(timecard.id, {include: !timecard.include})}
                      />
                    </TableCell>
                    <TableCell padding="none" variant="body" numeric>
                      <Button
                        aria-label="delete"
                        size="small"
                        onClick={() => editImportTime(timecard.id, { exclude: true, updated: true })}
                        style={{color: '#757de8'}}
                        >
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Tooltip>
      </Table>
  );
}

const mapStateToProps = (state) => ({
  crew: state.crewState,
  timecards: state.formData.importTimeMaterials.timecards,
  workTypes: state.workTypesState,
});

const mapDispatchToProps = {
  editImportTime,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ImportTime);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/ImportTime.jsx